import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { adminKeys } from "@/lib/query-keys";
import type { AdminPlan } from "@/types/domain";

/** Planes disponibles para asignar desde el panel de administración. */
export function useAdminPlans(enabled = true) {
  return useQuery({
    queryKey: adminKeys.plans,
    enabled,
    queryFn: async () => {
      const res = await fetchToBackend<any>("/admin/plans");
      return (res?.data ?? res ?? []) as AdminPlan[];
    },
  });
}
